import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import * as layouts from "../../Layouts/index";

import LoadingComponet from "../../components/Loading/LoadingComponet";
import GetPageData from "../../hooks/GetPageData";
import LayoutContainer from "../../components/LayoutsContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
}));

const FormsPage = () => {
  const classes = useStyles();
  const { ready, data, error } = GetPageData("gallery/main");

  return ready && data ? (
    <div className={classes.root}>
      <LayoutContainer>
        {data?.data?.map((data, index) => {
          const Layout = layouts[data?.layout];
          return <Layout key={index} data={data} />;
        })}
      </LayoutContainer>
    </div>
  ) : (
    <div>
      <LoadingComponet />
    </div>
  );
};
export default FormsPage;
